import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private readonly SESSION_SUBSCRIPTION_SOURCE_KEY = 'subscriptionSource';
  private readonly QR_LANDING_SOURCE_KEY = 'qrLandingSource';
  private readonly QR_LANDING_TENT_KEY = 'qrLandingTent';
  private readonly QR_LANDING_SOURCE_TTL_MS = 3 * 60 * 60 * 1000;

  public setQrLandingSource(): void {
    sessionStorage.setItem(this.QR_LANDING_SOURCE_KEY, Date.now().toString());
  }

  public isQrLandingSource(): boolean {
    const scannedAt = parseInt(sessionStorage.getItem(this.QR_LANDING_SOURCE_KEY), 10);
    return !!scannedAt && Date.now() - scannedAt < this.QR_LANDING_SOURCE_TTL_MS;
  }

  public deleteQrLandingSource(): void {
    sessionStorage.removeItem(this.QR_LANDING_SOURCE_KEY);
    sessionStorage.removeItem(this.QR_LANDING_TENT_KEY);
  }

  public setQrLandingTent(tent: string): void {
    sessionStorage.setItem(this.QR_LANDING_TENT_KEY, tent);
  }

  public getQrLandingTent(): string {
    return this.isQrLandingSource() ? sessionStorage.getItem(this.QR_LANDING_TENT_KEY) : null;
  }

  public setSubscriptionSource(source: string): void {
    sessionStorage.setItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY, source);
  }

  public getSubscriptionSource(): string {
    return sessionStorage.getItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY);
  }

  public deleteSubscriptionSource(): void {
    sessionStorage.removeItem(this.SESSION_SUBSCRIPTION_SOURCE_KEY);
  }
}
